import { HRM_PERMISSIONS } from './permissions';

const P = HRM_PERMISSIONS;

/**
 * Who may open a setup/catalog page (sidebar item and route): anyone holding at least one of its
 * write permissions. Reading these records for dropdowns elsewhere in the app is governed by the
 * data rules, so a user who only needs the list in a form never sees the manager page.
 */
export const HRM_MANAGE_PERMISSIONS = {
  DEPARTMENT: [P.DEPARTMENT.CREATE, P.DEPARTMENT.UPDATE, P.DEPARTMENT.DELETE],
  ROLE: [P.ROLE.VIEW, P.ROLE.CREATE, P.ROLE.UPDATE, P.ROLE.DELETE],
  DESIGNATION: [P.DESIGNATION.CREATE, P.DESIGNATION.UPDATE],
  LOCATION: [P.LOCATION.CREATE, P.LOCATION.UPDATE, P.LOCATION.DELETE],
  PROJECT: [P.PROJECT.CREATE, P.PROJECT.UPDATE, P.PROJECT.DELETE],
  SKILL_CATEGORY: [P.SKILL_CATEGORY.CREATE, P.SKILL_CATEGORY.UPDATE, P.SKILL_CATEGORY.DELETE],
  SKILL_SUB_CATEGORY: [
    P.SKILL_SUB_CATEGORY.CREATE,
    P.SKILL_SUB_CATEGORY.UPDATE,
    P.SKILL_SUB_CATEGORY.DELETE,
  ],
  SKILL: [P.SKILL.CREATE, P.SKILL.UPDATE],
  NOC_TYPE: [P.NOC_TYPE.CREATE, P.NOC_TYPE.UPDATE, P.NOC_TYPE.DELETE],
  CTC_LEVEL: [P.CTC_LEVEL.CREATE, P.CTC_LEVEL.UPDATE, P.CTC_LEVEL.DELETE],
  LEAVE_CATEGORY: [P.LEAVE_CATEGORY.CREATE, P.LEAVE_CATEGORY.UPDATE, P.LEAVE_CATEGORY.DELETE],
  HOLIDAY: [
    P.HOLIDAY.VIEW_LIST,
    P.HOLIDAY.CREATE,
    P.HOLIDAY.UPDATE,
    P.HOLIDAY.DELETE,
    P.HOLIDAY.MARK_CANTON_BASED,
  ],
  MBM_PROJECT: [P.MBM_PROJECT.CREATE, P.MBM_PROJECT.UPDATE],
  PERFORMANCE_FORM: [
    P.PERFORMANCE_FORM.CREATE,
    P.PERFORMANCE_FORM.UPDATE,
    P.PERFORMANCE_FORM.DELETE,
  ],
  SURVEY_FORM: [P.SURVEY_FORM.CREATE, P.SURVEY_FORM.UPDATE, P.SURVEY_FORM.DELETE],
} satisfies Partial<Record<keyof typeof HRM_PERMISSIONS, string[]>>;

/** The Skill Manager holds three catalogs, one tab each: it opens for whoever may manage any of them. */
export const SKILL_MANAGER_PERMISSIONS = [
  ...HRM_MANAGE_PERMISSIONS.SKILL_CATEGORY,
  ...HRM_MANAGE_PERMISSIONS.SKILL_SUB_CATEGORY,
  ...HRM_MANAGE_PERMISSIONS.SKILL,
];
